import i18next from 'i18next';
import { ProductAbbreviation } from '../../../../../types/product';

export const getButtonLabelByGame = (productAbbreviation: string, t: i18next.TFunction) => {
  switch (productAbbreviation) {
    case ProductAbbreviation.LOL:
      return t('GET free skin + discount*');
    case ProductAbbreviation.TFT:
      return t('GET free random Legend + discount*');
    default:
      return null;
  }
};
